import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { resetTimeFilters, updateTimeFilters } from '../../../../actions'
import { logTimeChipFilter } from '../../../../../common/log-ga-event'

/**
 * Time Dispatch Hooks - Redux slider event handling
 */
export function useTimeDispatch({ changeHandler, activeTabId }) {
  /**
   * Initialize redux hook
   */
  const dispatch = useDispatch()

  /**
   * Generic time handler
   */
  const dispatchChange = useCallback(
    ({ payload, entity, sliceRefId, activeTabId }) => {
      dispatch(
        updateTimeFilters({
          payload,
          entity,
          sliceRefId,
          sbsParams: {
            activeTabId,
          },
        })
      )

      if (changeHandler) {
        changeHandler()
      }
    },
    [changeHandler, dispatch]
  )

  /**
   * Change time handler for sliders
   */
  const baseTimeHandler = useCallback(
    (entity, sliceRefId) => {
      return (changed) => {
        const payload = changed.min ? changed : { min: changed[0], max: changed[1] }

        dispatchChange({ payload, entity, sliceRefId, activeTabId })
      }
    },
    [activeTabId, dispatchChange]
  )

  // Deselect is N, Select is Y
  const getGAEnabledState = (updatedTimes, activeTimes, entity) =>
    (!activeTimes && !!updatedTimes) || updatedTimes?.[entity]?.length > activeTimes?.[entity]?.length

  /**
   * Change time handler for chips
   */
  const handleTimeChipClick = (activeTimes, updatedTimes, entity, sliceRefId, label, isDynamic) => {
    dispatchChange({ payload: updatedTimes, entity, sliceRefId, activeTabId })
    logTimeChipFilter({
      type: entity,
      label,
      isDynamic,
      enabled: getGAEnabledState(updatedTimes, activeTimes, entity),
    })
  }

  /**
   * Reset for time chips
   */
  const resetHandler = useCallback(
    (type = 'time', shouldFireChange = true) => {
      dispatch(resetTimeFilters({ entity: type }))

      if (shouldFireChange && changeHandler) {
        changeHandler()
      }
    },
    [dispatch, changeHandler]
  )

  return {
    baseTimeHandler,
    handleTimeChipClick,
    resetHandler,
  }
}
